import React from 'react'

class Intro extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="intro intro--shortenMore">
        <div className="container">
          <div className="intro__content">
            <h1>In the Press</h1>
            <p>
              We’re building the infrastructure and official platform for high school esports. We’re proud of
              our coverage and hope you’ll join our story.
            </p>
          </div>
        </div>
        {/*<div className="intro__mask intro__mask--fadeToRight"></div>*/}
      </div>
    )
  }
}

export default Intro



// WEBPACK FOOTER //
// ./src/common/ui/components/IntroPress.js